module.exports = __webpack_public_path__ + "img/wxgzh.f1563e81.png";